<template>
  <div>
    <span v-if="rule.config.above_below == 'squeeze'">
      Keltner squeeze on the {{ rule.config.ma_days }}-day channel ({{ rule.config.atr_mult }} ATR)
    </span>
    <span v-else>
      Close {{ rule.config.above_below }} the {{ rule.config.ma_days }}-day Keltner Channel ({{
        rule.config.atr_mult
      }}
      ATR)
    </span>
  </div>
</template>

<script>
export default {
  props: {
    rule: { type: Object, required: true }
  }
}
</script>
